/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "@/shared/api/axiosInstance";
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  PostApiV1SerievideoVideoidLangsMutationRequest,
  PostApiV1SerievideoVideoidLangsMutationResponse,
  PostApiV1SerievideoVideoidLangsPathParams,
  PostApiV1SerievideoVideoidLangsQueryParams,
  PostApiV1SerievideoVideoidLangs400,
  PostApiV1SerievideoVideoidLangs401,
  PostApiV1SerievideoVideoidLangs404,
  PostApiV1SerievideoVideoidLangs500,
} from "../../types/serieVideoIdiomasController/PostApiV1SerievideoVideoidLangs.ts";

function getPostApiV1SerievideoVideoidLangsUrl(
  videoId: PostApiV1SerievideoVideoidLangsPathParams["videoId"],
) {
  const res = {
    method: "POST",
    url: `/api/v1/serievideo/${videoId}/langs` as const,
  };
  return res;
}

/**
 * @description Cria uma nova tradução (idioma) para o vídeo. **(Requer Authorization para autenticação)**
 * @summary Criar idioma do vídeo (Requer Authorization para autenticação)
 * {@link /api/v1/serievideo/:videoId/langs}
 */
export async function postApiV1SerievideoVideoidLangs(
  videoId: PostApiV1SerievideoVideoidLangsPathParams["videoId"],
  data?: PostApiV1SerievideoVideoidLangsMutationRequest,
  params?: PostApiV1SerievideoVideoidLangsQueryParams,
  config: Partial<
    RequestConfig<PostApiV1SerievideoVideoidLangsMutationRequest>
  > & { client?: Client } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const requestData = data;

  const res = await request<
    PostApiV1SerievideoVideoidLangsMutationResponse,
    ResponseErrorConfig<
      | PostApiV1SerievideoVideoidLangs400
      | PostApiV1SerievideoVideoidLangs401
      | PostApiV1SerievideoVideoidLangs404
      | PostApiV1SerievideoVideoidLangs500
    >,
    PostApiV1SerievideoVideoidLangsMutationRequest
  >({
    method: "POST",
    url: getPostApiV1SerievideoVideoidLangsUrl(videoId).url.toString(),
    params,
    data: requestData,
    ...requestConfig,
    headers: { "Content-Type": "application/*+json", ...requestConfig.headers },
  });
  return res.data;
}
